<script>
import { NodeMixin } from '@/helpers/node-mixin';
import { useConfig } from '@/helpers/config-effect';
import { computed } from 'vue';

export default {
  name: 'TriggerNode',
  template: '#trigger-node-template',
  props: {id: String},
  mixins: [NodeMixin],
  emits: ['click'],
  setup(props) {
    const config = useConfig();
    const triggerEvent = computed(() => {
      if (props.node.properties.arguments?.event?.id === 'custom') {
        return { name: `${props.node.properties.arguments?.event?.customEvent || ''} (Custom)` };
      }
      return config.triggers.events[props.node.properties.arguments?.event?.id] || { name: props.node.properties.arguments?.event?.id || 'N/A' };
    });

    const triggerSchedule = computed(() => {
      const schedule = config.triggers.schedules[props.node.properties.arguments?.schedule?.frequency] || { name: 'N/A' };
      const startsAt = props.node.properties.arguments?.schedule?.startDate;
      schedule.startsAt = startsAt ? (new Date(startsAt)).toLocaleString() : null;

      return schedule;
    });

    const triggerWebhook = computed(() => {
      const parameters = props.node.properties.arguments?.webhook?.parameters || {};

      return {
        slug: props.node.properties.arguments?.webhook?.slug || 'N/A',
        parameters: Object.keys(parameters).map(parameterId => parameters[parameterId].name || parameterId).join(', '),
        url: props.node.webhook_url,
      };
    });

    return {
      triggerEvent,
      triggerSchedule,
      triggerWebhook,
    };
  },
};
</script>
